export default __webpack_public_path__ + "e42ed7872d11fed3ce47e3fc946965e2.svg";